var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"theme-title",class:[{ '-ing': _vm.status === 1, '-before': _vm.status === 2 }]},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }